import React from "react";
import { Oval } from "react-loader-spinner";

const SuspenseLoader = () => {
	return (
		<>
			<div className="text-center">
				<div className="sweet-loading">
					<Oval height={80} width={80} color="#e0faa2" secondaryColor="#e0faa2" />
				</div>
			</div>
		</>
	);
};

export default SuspenseLoader;
